export enum Endpoints {
    ACTIVITY = 'activity',
    ACTIVITY_TYPES = 'activity-types',
    GET_ACTUATORS = 'actuators',
    GET_ACTUATOR_LOCATIONS = 'actuator-locations',
    TOGGLE_RELAY = 'toggle_relay',
    STATUS_ACTUATOR = 'status_actuator',
    ASSET = 'asset',
    ASSET_STATUSES = 'asset/statuses',
    BACKGROUND_URL = 'setting/background-url',
    CARD = 'card',
    CARD_LOGIN_ALLOWED = 'card-login',
    CARD_UPDATE = 'card-update',
    INVENTORY_UPDATE = 'inventory-update',
    LOCATION = 'location',
    LOG_IN = 'login',
    LOG_IN_NFC = 'login-nfc',
    PASSWORD_CHANGE_REQUIRED = 'password/change-required',
    LOG_OUT = 'logout',
    LOGO_URL = 'setting/logo-url',
    OPTIONS = 'options',
    PLACE_ORDER = 'place-order',
    REFRESH_TOKEN = 'refresh-token',
    REQUEST_ACTIVITY = 'request-activity',
    USER_ASSET_ASSIGNMENT = 'user-asset-assignment',
    SEARCH = 'search',
    USER_STATUS_HEART_BEAT = 'heart-beat',
}
